import React from "react";
import styles from "../../styles/pages/createSecondPage.module.scss";
import UploadDoc from "../DocumentUploader";
import UploadDocument from "../uploadFile";
import Icons from "../../public/assets/svg";
import { BlobServiceClient } from "@azure/storage-blob";
import endpoints from '../../utility/endpoints'

export default (props) => {
  // console.log(props, "FORMTYPE ATTHE UPLOAD")
  const [modalShow, setModalShow] = React.useState(false);

  const blobSasUrlNew = endpoints.blobSasUrlNew
  //   "https://newbotstore.blob.core.windows.net/?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-04-03T15:11:13Z&st=2021-04-03T07:11:13Z&spr=https&sig=yJGmi7uHf8DAG%2BfT%2FOsKBLFP3URycUiPaPRocqIqSh8%3D";

  const blobServiceClient = new BlobServiceClient(blobSasUrlNew);
  const containerClient = blobServiceClient.getContainerClient(
    `botstorevideo/botDocuments/${props.savedState.documentFolderName}`
  );




  let documentAr = [
    { title: "SOP", value: "sopDocument", type: [".pdf",".doc",".docx", ".msg", ".png", ".jpeg", ".jpg", ".xls", ".xlsx", ".ppt", ".pptx"] },
    { title: "PDD", value: "pddDocument", type: [".pdf",".doc",".docx"] },
    { title: "PDD Approval", value: "pddApprovalDocument", type: [".msg",".png"] },
    { title: "SDD", value: "sddDocument", type: [".pdf",".doc",".docx"] },
    { title: "QSG", value: "qsgDocument", type: [".doc",".docx"] },
    { title: "ODI", value: "odiDocument", type: [".xlxs",".xls"] },
    { title: "BRD", value: "brdDocument", type: [".xlxs",".xls"] },
    {
      title: "Cost Apporval",
      value: "costApprovalDocument",
      type:  [".msg",".png"],
    },
    {
      title: "Landscape Approval",
      value: "explicitLandscapeApplicationOwnerApprovalDocument",
      type: ".msg",
    },
    {
      title: "GPM Approval",
      value: "explicitGPMApprovalSupplyChainFinanceDocument",
      type: [".msg",".png"],
    },
    {
      title: "GFCF Approval",
      value: "explicitGFCFApprovalDocument",
      type: [".msg",".png"],
    },
    {
      title: "Dev Quality Crendentails Available",
      value: "devQualityCredentialsAvailableDocument",
      type: ".msg",
    },
    {
      title: "Infosec Approval",
      value: "infosecApprovalDocument",
      type: ".msg",
    },
    {
      title: "DA Review Sign Off",
      value: "dAReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "Test Data Development",
      value: "testDataAvailableForDevelopmentDocument",
      type: [".xlxs",".xls"],
    },
    {
      title: "Request Raised Product Credentials",
      value: "requestRaisedForProductionCredentialsDocument",
      type: ".msg",
    },
    {
      title: "Internal Testing Completed",
      value: "internalTestingCompletedDocument",
      type: ".msg",
    },
    {
      title: "Peer Review Sign Off",
      value: "peerReviewSignOffDocument",
      type: ".msg",
    },
    {
      title: "DA Review Second Sign Off",
      value: "daReviewSecondSignOffDocument",
      type: ".msg",
    },
    {
      title: "BP Release Sign Off",
      value: "bpReleaseSignOffFromDaDocument",
      type: ".msg",
    },
    {
      title: "UAT Scripts With Results",
      value: "uatScriptsWithResultsDocument",
      type: [".xlxs",".xls"],
    },
  
    {
      title: "Release Manager Sign Off",
      value: "releaseManagerSignOffDocument",
      type: ".msg",
    },
    { title: "Gate Form", value: "gateFormDocument", type: [".xlxs",".xls"] },
    {
      title: "Peer Review Checklist",
      value: "peerReviewchecklistDocument",
      type: [".xlxs",".xls"],
    },
    { title: "QA Sign Off", value: "qaSignOffDocument", type: ".msg" },
    { title: "Walk Through Video", value: "walkthroughVideo", type: [".mov",".mp4",".avi"] },
    { title: "KT Video", value: "ktVideo", type:  [".mov",".mp4",".avi"] },
  ];

  const openDocumentModal = () => {
    let modal = !modalShow;
    setModalShow(true);

    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };

  const closeDocumentModal = () => {
    let modal = !modalShow;
    setModalShow(false);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  };



  const [uploadedFileToShow, setUploadedFileToShow] = React.useState(null);
  const [totalUploadedItems, setTotalUploadedItems] = React.useState(null);
  const [uploadedDocumentsState, setUploadedDocumentsState] = React.useState(
    null
  );
  const [invalid, setInvalid] = React.useState(false)

  const gotDocInfo = (name, url, title, uploadedItems, extension) => {
    let ar = url.split("?");
    let another = ar[0].split("/");
    let toSend = another[another.length - 1];
    // console.log(title, uploadedItems, "uploaded data of data");
    // console.log(name, "nameat uploaderrr", title)
    //console.log(extension, "extension at 56")
  //  setUploadedFileToShow(title);
    setTotalUploadedItems(uploadedItems);
    props.sendDocInfo(name, toSend, extension);
  };



  // React.useEffect(() => {

  // }, [props.savedState.uploadDocumentsState]);


  const sendAllInfoAboutUploadModal = (
    uploaded,
    totalItems,
    uploadedItems,
    originalFileNames,
    azureFileNames,
    deleteDocumentsLater,
    presentState
  ) => {

    if (uploaded.sopDocument) {

      props.setSopInvalid(false)
    }
    else {

      props.setSopInvalid(true)
    }

    {/*console.log("sab console kara lo",  uploaded,"1",
    totalItems,"22",
    uploadedItems, "33",
    originalFileNames,"44",
    azureFileNames,"555",
    deleteDocumentsLater,"6666",
    presentState)
*/}
   

   //setUploadedFileToShow(documentAr.filter((item) => item.value === Object.keys(presentState)[Object.keys(presentState).length-1])[0].title)
   //console.log(azureFileNames, "azurefiles234latest")
   //console.log(uploadedDocumentsState, "azurefiles234previous")
   let deleteDocumentsLaterToSet = []
   if (uploadedDocumentsState && uploadedDocumentsState.deleteDocumentsLater && uploadedDocumentsState.deleteDocumentsLater.length>0){
     deleteDocumentsLaterToSet = [...uploadedDocumentsState.deleteDocumentsLater]
     for (let i in uploadedDocumentsState.azureFileNames) {
      if (!(i in azureFileNames)){
        deleteDocumentsLaterToSet.push(uploadedDocumentsState.azureFileNames[i])
      }
    }
   }
  
  

    setUploadedDocumentsState({
      uploaded,
      totalItems,
      uploadedItems,
      originalFileNames,
      azureFileNames : {...azureFileNames},
      deleteDocumentsLater : [...deleteDocumentsLaterToSet],
    });
    setTotalUploadedItems(uploadedItems)
    props.saveUploadDocumentStateInRedux({
      uploaded,
      totalItems,
      uploadedItems,
      originalFileNames,
      azureFileNames : {...azureFileNames},
      deleteDocumentsLater : [...deleteDocumentsLaterToSet],
      
    }, presentState);
  };



  React.useEffect(() => {

    if (
      props.savedState.botDemoVideo != "" &&
      props.savedState.botDemoVideo != null
    ) {

      setDemoVideoUploaded(true);
      setDemoVideoOriginalFileNames(props.savedState.botDemoVideo);
    }

    if (props.savedState.uploadDocumentsState) {



      setUploadedDocumentsState(props.savedState.uploadDocumentsState);
      for (let i in props.savedState.uploadDocumentsState.uploaded) {
        if (props.savedState.uploadDocumentsState.uploaded[i] == true) {
        //  setUploadedFileToShow(i)
          setTotalUploadedItems(
            props.savedState.uploadDocumentsState.uploadedItems);
          break;
        }
      }
    } else if (props.formType == "editBot" || props.formType == "createRollout") {

      if (props.savedState) {
        let documentsInfoToBeEdited = [];
        //console.log(props.savedState, "asdsd");
        for (let i in documentAr) {
          for (let j in props.savedState) {
            // console.log("j",j)
            if (
              j == documentAr[i].value &&
            //  props.savedState[j].length !== 0 &&
              props.savedState[j] !== "can be empty" && props.savedState[j] !== "NA" && props.savedState[j] !== "" && props.savedState[j] !== null && props.savedState[j] !== undefined
            ) {
              documentsInfoToBeEdited.push({ [j]: props.savedState[j] });
            }
          }
        }
        // console.log(documentsInfoToBeEdited, "documentsInfoToBeEdited");
        let uploaded = {};
        let totalItems = 28;
        // console.log('number of supprting Documents  ---', documentAr.length);
        let uploadedItems = documentsInfoToBeEdited.length;
        let originalFileNames = {};
        let azureFileNames = {};
        documentsInfoToBeEdited.map((item, index) => {
          uploaded = { ...uploaded, [Object.keys(item)[0]]: true };
          originalFileNames = { ...originalFileNames, ...item };
          azureFileNames = { ...azureFileNames, ...item };
        });
        // console.log(
        //   uploaded,
        //   "uploaded",
        //   originalFileNames,
        //   "original",
        //   azureFileNames
        // );
       // setUploadedFileToShow(Object.keys(uploaded)[0])
        setTotalUploadedItems(uploadedItems)
        setUploadedDocumentsState({
          uploaded,
          totalItems,
          uploadedItems,
          originalFileNames,
          azureFileNames,
        });
      }
    }
  }, []);



  const [demoVideoAzureFileName, setDemoVideoAzureFileName] = React.useState("");
  const [demoVideoUploaded, setDemoVideoUploaded] = React.useState(false);
  const [demoVideoOriginalFileNames, setDemoVideoOriginalFileNames] = React.useState("");
  const [demoVideoCouldNotUpload, setDemoVideoCouldNotUpload] = React.useState(false);


  const uploadFile = async (file, name, title, originalFileName) => {
    // console.log(file, "sdds", name, "vvv", title, "bbbb", originalFileNames);
    let fileName =   name + Date.now();
    setDemoVideoAzureFileName(fileName);
    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file.type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      setDemoVideoUploaded(true);
      setDemoVideoOriginalFileNames(originalFileName);
      let demoVideoUrl = resp._response.request.url
      let ar = demoVideoUrl.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];
      props.sendDocInfo(name, toSend);
      //props.setUploadedFileToShowOutside(title)
      // props.sendDemoVideo(
      //   name,
      //   resp._response.request.url,
      //   title,
      //   uploadedItems + 1
      // );
    } catch (error) {
      setDemoVideoCouldNotUpload(true);
      setDemoVideoUploaded(false);
    }
  };

  const deleteDemoVideo = async () => {
    setDemoVideoOriginalFileNames("")
    setDemoVideoUploaded(false)
    setDemoVideoAzureFileName("")
    props.deleteDemoVideo()
    try {
      await containerClient.deleteBlob(demoVideoAzureFileName);
    }
    catch (err) {
      console.log(err)
    }


    // console.log(uploaded, "xadsda", name)

  }

  return (
    <div className="container mb-3">
      <div className={styles.commmonUploader}>
        <div className={styles.documentUploader}>
          <p>Upload Documents</p>
          <div className={styles.document}>
            <span className={styles.btnUpload} onClick={openDocumentModal}>
              Open Document Uploader
            </span>
            <span className={styles.text}>
              {props.sopInvalid ? (
                <span style={{ color: "red" }}>
                  Please upload SOP Document
                </span>
              ) : 
                totalUploadedItems != null &&
                totalUploadedItems !== 0 ? (
                `${"SOP document"} ${totalUploadedItems == 1
                  ? ""
                  : `+ ${totalUploadedItems - 1} file${totalUploadedItems-1 == 1 ? "" : "s"}`
                } uploaded`
              ) : (
                `Files not uploaded`
              )}
            </span>
          </div>
        </div>

        <div className={styles.documentUploader}>
          <p>Bot Demo Video</p>
          <div className={styles.document}>
          
            <div className = {styles.demoVideoUpload}>
            <UploadDocument
              data={true}
              title={"Bot Demo Video"}
              value={"botDemoVideo"}
              fileType={[".mov", ".avi", ".mp4"]}
              uploadFile={uploadFile}
              uploaded={demoVideoUploaded}
              couldNotUpload={demoVideoCouldNotUpload}
              originalFileName={demoVideoOriginalFileNames}
              type="createBot"
            />
            </div>
            <div onClick={() => deleteDemoVideo()} style={{ left: "80%", cursor: "pointer", position: "relative" }}>
              <Icons name="deleteicon" className={styles.icon} />
            </div>
          </div>
        </div>

        <div className={styles.uploadContainer}>
          {modalShow == true ? (
            <UploadDoc
              closeModal={closeDocumentModal}
              sendDocInfo={gotDocInfo}
              sendAllInfoAboutUploadModal={sendAllInfoAboutUploadModal}
              uploadedDocumentsState={uploadedDocumentsState}
              formType={props.formType}
              documentFolderName = {props.savedState.documentFolderName}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
